import React from 'react';
import Layout from "@/Shared/Layout";
import {InertiaLink, useForm, usePage} from "@inertiajs/inertia-react";
import {Inertia} from "@inertiajs/inertia";
import DeleteButton from "@/Shared/DeleteButton";
import LoadingButton from "@/Shared/LoadingButton";
import CategoryForm from "@/Pages/Categories/Assets/CategoryForm";

const Edit = () => {
  const {category} = usePage().props;

  const {data, setData, errors, post, processing} = useForm({
    category_id: category.category_id,
    category_title: category.category_title || '',
    page_title: category.page_title || '',
    short_title: category.short_title || '',
    relative_url: category.relative_uri || '',
    showonline: category.showonline || 0,
    make_visible: category.make_visible || 0,
    logo: '',
    rank: category.rank || 0,
    keywords: category.keywords || '',
    category_description: category.category_description || '',
    meta_description: category.meta_description || '',
    start_date: category.start_date || null,
    expire_date: category.end_date || null,
  });

  function handleSubmit(e) {
    e.preventDefault();
    post(route('categories.update', category.category_id).url());
  }

  function destroy() {
    if (confirm('Are you sure you want to delete this category?')) {
      Inertia.delete(route('categories.destroy', category.category_id));
    }
  }

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('categories')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Categories
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Edit
      </h1>
      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          <CategoryForm errors={errors} data={data} setData={setData} />
          <div className="flex items-center justify-between px-8 py-4 bg-gray-100 border-t border-gray-200">
            <DeleteButton onDelete={destroy}>Delete Category</DeleteButton>
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Edit Category
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Edit.layout = page => <Layout title="Edit category" children={page}/>;

export default Edit;
